import React from 'react'

import Svg from '../svg'


export default function CreatedIcon({width, height, color, ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--content-color') || color

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="sort" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path d="M32.7920843,94.5286483 C15.9117703,87.418942 4,70.1610239 4,50 C4,23.490332 24.5949015,2 50,2 C75.4050985,2 96,23.490332 96,50 C96,71.0631061 82.9984248,88.9575019 64.9128248,95.421396 C57.4196018,86.171438 51.6521345,71.4988949 48.8572982,54 L48.1427018,54 C45.4361522,70.9461188 39.9418112,85.2416299 32.7920843,94.5286483 L32.7920843,94.5286483 Z M50,39 C55.5228475,39 60,34.5228475 60,29 C60,23.4771525 55.5228475,19 50,19 C44.4771525,19 40,23.4771525 40,29 C40,34.5228475 44.4771525,39 50,39 Z" id="Shape" fill={color || "white"}></path>
        </g>
    </Svg>
}
